import { Suspense, useEffect } from 'react';
import { useChatWindow } from '@/contexts/ChatWindowContext';
import { lazyModule } from '@/lib/lazyModule';

// Lazy: nothing of the chat window is downloaded until it is opened once.
const MiniChat = lazyModule(() => import('./MiniChat').then((m) => ({ default: m.MiniChat })));

export function ChatMount() {
  const { state } = useChatWindow();

  // Fetch and evaluate the chunk while the browser is idle, so the first click
  // does not pay for it.
  useEffect(() => {
    const warm = () => void import('./MiniChat');
    if (typeof requestIdleCallback === 'function') {
      const handle = requestIdleCallback(warm, { timeout: 5000 });
      return () => cancelIdleCallback(handle);
    }
    const timer = window.setTimeout(warm, 3000);
    return () => window.clearTimeout(timer);
  }, []);

  if (state === 'closed') return null;

  return (
    <Suspense fallback={null}>
      <MiniChat />
    </Suspense>
  );
}
